import React, {Fragment} from 'react';
import isEqual from 'lodash-es/isEqual';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { ChromePicker } from 'react-color';
import Button from "./Button";
import debounce from "lodash-es/debounce";

export default class ColorPicker extends React.Component {

    static propTypes = {
        onBlur: PropTypes.func,
        saveChanges: PropTypes.func,
        onKeyDown: PropTypes.func,
        type: PropTypes.oneOf(["string","text","number","decimal"]),
        label: PropTypes.any,
        focus: PropTypes.bool,
        select: PropTypes.bool,
        required: PropTypes.bool,
        disabled: PropTypes.oneOf([true, false, "true", "false", "disabled"]),
        readOnly: PropTypes.any,
        error: PropTypes.any,
        value: PropTypes.any,
        placeholder: PropTypes.any,
        name: PropTypes.string,
        className: PropTypes.any,
        disableAlpha: PropTypes.bool,
        isClearable: PropTypes.bool
    };

    constructor(props) {
        super(props);
        this.state = {
            displayColorPicker: false,
            value: this.props.value
        };
        this.saveChanges = debounce((color, event) => {
            if (this.props.saveChanges) {
                this.props.saveChanges(this.props.name, color.hex, event);
            }
        }, 300);
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.value + "" !== "" + prevProps.value) {
            this.setState({
                value: this.props.value
            });
        }
    }

    onChange = (color, event) => {
        // color = {
        //   hex: '#333',
        //   rgb: {
        //     r: 51,
        //     g: 51,
        //     b: 51,
        //     a: 1,
        //   },
        //   hsl: {
        //     h: 0,
        //     s: 0,
        //     l: .20,
        //     a: 1,
        //   },
        // }
        this.setState({
            value: color.hex
        });
    }

    onChangeComplete = (color, event) => {
        this.onChange(color, event);
        this.saveChanges(color, event);
    }

    handleClick = () => {
        this.setState({ displayColorPicker: !this.state.displayColorPicker })
    };

    handleClose = () => {
        this.setState({ displayColorPicker: false })
    };

    render() {
        let style = {};
        if (this.props.label === false) {
            style.display = "none";
        }
        const popover = {
            position: 'absolute',
            zIndex: '2',
        }
        const cover = {
            position: 'fixed',
            top: '0px',
            right: '0px',
            bottom: '0px',
            left: '0px',
        }
        return (
            <Fragment>
                <label htmlFor={this.props.name} className="control-label" style={style}>{this.props.label} {this.props.required && <span className="invalid-feedback">*</span>}</label>
                <div className={classNames({"input-group": this.props.isClearable && this.state.value})}>
                    <Button block={true} onClick={this.handleClick} color="default" className="color-picker-button"><span className="image-styled-background" ><span style={{backgroundColor: this.state.value}} /></span></Button>
                    {this.props.isClearable && this.state.value && <span className="input-group-btn">
                        <Button icon={{lib: "fa", name: "times"}} color="default" onClick={() => this.props.saveChanges(this.props.name, null)} disabled={ this.props.disabled === "true" || this.props.disabled === "disabled" || this.props.disabled } />
                    </span>}
                </div>
                {this.state.displayColorPicker ? <div style={popover}>
                    <div style={cover} onClick={this.handleClose}/>
                    <ChromePicker onChange={this.onChange} onChangeComplete={this.onChangeComplete} color={this.state.value || "#ffffff"} disableAlpha={this.props.disableAlpha !== undefined ? this.props.disableAlpha : true}/>
                </div> : null }
            </Fragment>
        );
    }
}